//TODO: split this in multiple files
const routes = {
  payment: '/stripe/payment',
  subscription: '/stripe/subscription',
  profile: '/user/profile',
  stripeUser: '/stripe/user',
  stripeProducts: '/stripe/products',
  stripePromotions: '/stripe/promotions',
  userMonitor: '/user/monitor',
  companyMonitor: '/company/monitor',
  searchCompany: '/company/search/business', // old version , kill after 'search' route fully implemented
  search: '/company/search/business',
  count: '/company/count',
  publicSearch: '/company/search/public',
  instaTouch: '/equifax/validate-compare',
  mobileIdInit: '/equifax/validate-start',
  mobileIdStatus: '/equifax/validate-status',
  mobileIdCallback: '/equifax/validate-callback',
  mobileIdStart: '/equifax/validate-redirect',
  equifaxCashflowInsights: '/equifax/cashflow-insights',
  equifaxPaymentInsights: '/equifax/payment-insights',
  equifaxMetric: '/equifax/cashflow-insights/confirm',
  kycUser: '/user/kyc',
  userBusinessIds: '/user/businesses',
  businessDetails: '/business/details-by-user-status',
  getBusinessProfile: '/business/profile',
  userBusiness: '/user/business',
  userBusinessProfile: '/user/business/profile',
  businessAvatar: '/user/business/photo',
  businessAvatarDel: '/user/business/photo/delete',
  deleteKeyPeople: '/user/business/delete-key-people',
  userBusinessInfo: '/user/business/info',
  userBusinessKeyPeople: '/user/business/key-people',
  userAbandonedPayment: '/analytics/payment-abandoned',
  feed: '/news/feed',
  businessCategories: '/company/categories',
  countriesCodes: '/company/country-codes',
  stateCodes: '/company/state-codes',
  stateName: '/country/state',
  businessTitles: '/company/titles',
  displayField: '/user/business/toggle-display',
  ekataVerification: '/ekata/submit-for-review',
  reviewRequestsList: '/admin/validation-requests',
  reviewRequestItem: '/admin/validation-requests',
  reviewRequestApprove: '/admin/validation-requests/approve',
  reviewRequestDecline: '/admin/validation-requests/decline',
  businessResources: '/api/business-resource-center',
  getDashboardInfo: '/aggregate',
  getCashflowData: '/graph/cashflow',
  getCashflowChartData: '/v2/graph/cashflow',
  getCashflowTableData: '/cashflow/details',
  getPayablesData: '/graph/payable',
  getPayablesChartData: '/v2/graph/payable',
  getPayablesTableData: '/payable/details',
  getReceivablesData: '/graph/receivable',
  getReceivablesChartData: '/v2/graph/receivable',
  getCashflowGraphData: '/v2/graph/cashflow',
  getPayablesGraphData: '/v2/graph/payable',
  getPayableBillSummary: '/payable/summary',
  getReceivablesGraphData: '/v2/graph/receivable',
  getReceivablesTableData: '/receivable/details',
  getSalesTableData: '/trx/details',
  getSalesTransactions: '/graph/trx',
  getSalesTransactionChartData: '/v2/graph/trx',
  getSalesVolume: '/graph/salevolume',
  getSalesVolumeChartData: '/v2/graph/salevolume',
  // getSalesCustomers: '/graph/customer',
  getSalesDisputes: '/graph/dispute',
  getSalesDisputeChartData: '/v2/graph/dispute',
  getUser: '/user',
  getTransactionDetailsTableData: '/trx/details',
  getSaleVolumeTableData: '/salevolume/details',
  getDisputeTableData: '/dispute/details',
  getBusiness: '/business',
  createBusinessDefault: '/business/default',
  userProfileComplete: '/user/profile/reset-complete',
  getAlerts: '/user/alerts',
  businessInfo: '/info',
  alertDeliveryMethods: '/user/alert/delivery-method',
  alertContacts: '/user/alert/preference',
  saveContact: '/user/alert/save-contact',
  userAvatar: '/user/avatar',
  saveDeliveryMethods: '/user/alert/save-delivery-method',

  codatUserInfo: '/integration/business/all',
  connectApp: '/integration/codat/register',
  disconnectApp: '/integration/connection/disconnect',
  userAccountType: '/user/account',
  storeStripeAuth: '/user/auth',
  profileCheck: '/user/profile/check',
  profileCreatePassword: '/user/profile/reset',

  // Get filter options
  getCashflowTrxType: '/cashflow/trx/type',
  getPayableBillStatus: '/payable/bill/status',
  getReceivableInvoiceStatus: '/receivable/invoice/status',
  getDisputePaymentStatus: '/dispute/payment/status',
  getTransactionPaymentMethod: '/trx/payment/method',
  getTransactionPaymentStatus: '/trx/payment/status',
  getTransactionType: '/trx/type',
  getReceivableInvoiceSummary: '/receivable/summary',

  // NAV Integration
  getNavUserDetailsFrom: '/integration/nav',
  getNavCTADetails: '/integration/nav/CTA',
  getNavToken: '/integration/nav/token',

  // Payment Integration
  stripePaymentMethods: '/stripe/paymentmethod',

  //EPSG Link
  userToken: '/user/token',
  badgedProfile: '/user/badged-profile',

  //Correct your Data
  legalInfo: '/business/legal-info',
  contactInfo: '/business/contact-info',
  descriptiveInfo: '/business/descriptive',
  stateContactInfo: '/business/state-contact-info',

  // Business Partner Solutions
  businessPartnerSolutions: '/business_partner_solutions',
  businessPartnerSolutionsAudits: '/business_partner_solutions/audits',
}

const vaultAPIRoutes = {
  getVaultSummary: '/vault',
  vaultOTP: '/vault/otp',
  vaultDocument: '/vault/article',
  vaultBOdisplay: '/vault/beneficiary-owner-display',
  vaultBO: '/vault/beneficiary-owner',
  vaultUserAlert: '/vault/user-alert',
  vaultRetrieveBOInfo: '/vault/retrieve-beneficiary-owner-invitation-details',
  vaultPostBoInfo: '/vault/store-beneficiary-business-owner-invitation-details',
  vaultPostBoIndividualInfo: '/vault/store-beneficiary-individual-owner-invitation-details',
  vaultBOResendInvite: '/vault/beneficiary-owner-invite/resend',
  vaultDeliveryMethods: '/vault/sec-share/delivery-method',
  vaultExpiration: '/vault/sec-share/expiration-interval',
  vaultRecipient: '/vault/sec-share/recipient-info',
  vaultGeneratePassword: '/vault/sec-share/generate-password',
  vaultTriggerEmail: '/vault/sec-share/trigger-email',
  vaultTriggerApprovalEmail: '/vault/sec-share/trigger-approval-email',
  vaultAprroveDeclineBoShare: '/vault/sec-share/handle-approval-requests',
}

const index = { ...routes, ...vaultAPIRoutes }

export default index
